export default {
  modelName: 'platform_stock',
  fields: {
    name: {
      type: 'text',
      label: '標題',
      rules: 'required',
      maxlength: 100,
    },
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    source_url: {
      type: 'text',
      label: 'url',
      rules: 'required',
      maxlength: 100,
    },
    file_type: {
      type: 'text',
      label: '檔案類型',
      rules: 'required',
      maxlength: 100,
    },
  },
};